import { WidgetBlockToViewBlockHoC, WidgetBlockWrapper } from '../../state-management';
import IWidgetBlock from '../types/IWidgetBlock';
import defaultState from './defaultState';
import reducer from './reducer';
import StaticImage from './StaticImage';
import { StaticImageConfigBlockState, StaticImageState } from './types';

const WidgetBlock: IWidgetBlock<StaticImageConfigBlockState, StaticImageState> = {
    label: 'Static Image',
    type: 'staticImage',
    defaultState,
    mimeTypes: [],
    reducer,
    widgetBlock: WidgetBlockWrapper(StaticImage),
    render: WidgetBlockToViewBlockHoC(reducer, StaticImage),
    widgetComponent: StaticImage,
};

export default WidgetBlock;
